// Centralised data-testid registry for Ultra
export const TID = {
  // Landing
  landingNav: "landing-nav",
  landingHero: "landing-hero",
  landingCtaPrimary: "landing-cta-primary",
  landingCtaSecondary: "landing-cta-secondary",
  landingPricing: "landing-pricing",
  landingFooter: "landing-footer",

  // Auth
  loginForm: "login-form",
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  loginGoogle: "login-google-button",
  loginGoToRegister: "login-go-register",

  registerForm: "register-form",
  registerLegalName: "register-legal-name",
  registerTradeName: "register-trade-name",
  registerCnpj: "register-cnpj",
  registerPhone: "register-phone",
  registerAdminName: "register-admin-name",
  registerEmail: "register-email",
  registerPassword: "register-password",
  registerPlan: "register-plan",
  registerSubmit: "register-submit",
  registerGoToLogin: "register-go-login",

  // Layout
  sidebar: "app-sidebar",
  sidebarLogo: "sidebar-logo",
  topbar: "app-topbar",
  topbarUserMenu: "topbar-user-menu",
  logoutButton: "logout-button",
  switchToAdmin: "switch-to-admin",
  switchToTenant: "switch-to-tenant",

  // Dashboard
  dashboard: "tenant-dashboard",
  kpiUnits: "kpi-units",
  kpiUsers: "kpi-users",
  kpiCompliance: "kpi-compliance",
  kpiOccurrences: "kpi-occurrences",

  // Admin – Companies
  adminCompanies: "admin-companies",
  adminCompaniesNew: "admin-companies-new",
  companyRow: "company-row",
  companySuspend: "company-suspend",
  companyReactivate: "company-reactivate",
  companyCancel: "company-cancel",
  companyEdit: "company-edit",
  companyFlags: "company-flags",
  companyFlagsSave: "company-flags-save",

  // Admin – Plans
  adminPlans: "admin-plans",
  planNew: "plan-new",
  planSubmit: "plan-submit",

  // Admin – Subscriptions, Payments, Metrics, Tickets, Audit, Monitoring
  adminSubscriptions: "admin-subscriptions",
  adminPayments: "admin-payments",
  adminMetrics: "admin-metrics",
  adminTickets: "admin-tickets",
  adminTicketRow: "ticket-row",
  adminAudit: "admin-audit",
  adminMonitoring: "admin-monitoring",

  // Tenant
  units: "tenant-units",
  unitsNew: "unit-new",
  unitsSubmit: "unit-submit",
  users: "tenant-users",
  usersNew: "user-new",
  usersSubmit: "user-submit",
  settings: "tenant-settings",

  // Pricing
  pricing: "pricing-page",
  pricingPlan: "pricing-plan",
  pricingCheckout: "pricing-checkout",

  // Payment success
  paymentSuccess: "payment-success",
  paymentSuccessStatus: "payment-success-status",
};

export const HOME = { emergentLink: "emergent-link" };
